

import React, { useEffect, useState } from 'react';
import { Wheel } from 'react-custom-roulette';
import confetti from 'canvas-confetti';
import "../ScrollReveal.css";
import {
  collection,
  query,
  where,
  getDocs,
  addDoc,
  Timestamp,
} from 'firebase/firestore';
import { userDb } from '../firebaseUsers'; // your Firebase DB config
import ShippingGift from './ShippingGift';

const SpinningWheelGame = ({ onSubmit, showLoginModal, login }) => {
  const [userList, setUserList] = useState([]);
  const [winner, setWinner] = useState(null);
  const [hasSpun, setHasSpun] = useState(false);
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [show, setShow] = useState(false);
  const now = new Date();
  const previousMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
  const yearOfPreviousMonth = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
  const prize = "/images/assets/$1000.jpg"
  useEffect(() => {
    const fetchUsersAndWinner = async () => {
      try {
        // 1. Check if winner already exists for the previous month/year
        const winnersRef = collection(userDb, 'winners');
        const winnerQuery = query(
          winnersRef,
          where('month', '==', previousMonth),
          where('year', '==', yearOfPreviousMonth)
        );
        const winnerSnapshot = await getDocs(winnerQuery);

        if (!winnerSnapshot.empty) {
          const data = winnerSnapshot.docs[0].data();
          setWinner(data.winner);
          setHasSpun(true);
          return;
        }

        // 2. Fetch all users
        const usersRef = collection(userDb, 'users');
        const usersSnapshot = await getDocs(usersRef);
        const usersArray = usersSnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            option: data.username,
            email: data.email,
            id: doc.id,
            raw: data,
          };
        });

        setUserList(usersArray);
      } catch (error) {
        console.error("Error fetching users or winner:", error);
      }
    };

    fetchUsersAndWinner();
  }, [previousMonth, yearOfPreviousMonth]);

  const handleSpinClick = () => {
    if (userList.length === 0 || hasSpun) return;
    const randomIndex = Math.floor(Math.random() * userList.length);
    setPrizeNumber(randomIndex);
    setMustSpin(true);
  };

  const onStopSpinning = async () => {
    setMustSpin(false);
    const selectedUser = userList[prizeNumber];
    setWinner(selectedUser.option);
    setHasSpun(true);

    confetti({
      particleCount: 200,
      spread: 100,
      origin: { y: 0.6 },
    });

    try {
      await addDoc(collection(userDb, 'winners'), {
        winner: selectedUser.option,
        email: selectedUser.email,
        uid: selectedUser.raw.uid,
        month: previousMonth,
        year: yearOfPreviousMonth,
        createdAt: Timestamp.now(),
      });
    } catch (error) {
      console.error("Error saving winner:", error);
    }
  };

  return (
    <div
      style={{
        textAlign: 'center',
        marginTop: 50,
        padding: 30,
        borderRadius: 20,
        background: 'linear-gradient(to right, #ffecd2, #fcb69f)',
        boxShadow: '0 0 40px rgba(0, 0, 0, 0.2)',
        maxWidth: 600,
        margin: '50px auto',
      }}
    >
      <h2
        style={{
          fontSize: '2.5rem',
          color: '#333',
          fontWeight: 'bold',
          animation: 'fadeInDown 1s ease-in-out',
          marginBottom: 20,
        }}
      >
        🎡 Monthly Prize Wheel
      </h2>

      {userList.length > 0 && !hasSpun && (
        <button
          onClick={handleSpinClick}
          style={{
            padding: '12px 28px',
            fontSize: '20px',
            background: 'linear-gradient(to right, #00b09b, #96c93d)',
            color: 'white',
            border: 'none',
            borderRadius: '50px',
            cursor: 'pointer',
            boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
            transition: 'transform 0.2s ease-in-out',
            marginBottom: 30,
          }}
          onMouseEnter={(e) => (e.target.style.transform = 'scale(1.05)')}
          onMouseLeave={(e) => (e.target.style.transform = 'scale(1)')}
        >
          🎯 Spin Now!
        </button>
      )}

      {hasSpun && winner && (
        <>
          <h3
            style={{
              color: '#d63384',
              fontSize: '2rem',
              marginTop: 30,
              textShadow: '0 0 10px #fbc2eb',
              animation: 'popIn 1s ease-out',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            🏆 Winner for month {previousMonth + 1} is:
            <p style={{ marginTop: 10 }}>{winner}</p>
          </h3>
          <img src={prize} alt="" className="prize-image" />
        </>
      )}

      {userList.length > 0 && (
        <div className="wheel" style={{ maxWidth: 400, marginTop: 25 }}>
          <Wheel
            mustStartSpinning={mustSpin}
            prizeNumber={prizeNumber}
            data={userList}
            backgroundColors={['#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1']}
            textColors={['black']}
            fontSize={12}
            outerBorderColor={'#ffffff'}
            outerBorderWidth={6}
            innerBorderColor={'#cccccc'}
            radiusLineColor={'#eeeeee'}
            radiusLineWidth={3}
            onStopSpinning={onStopSpinning}
            spinDuration={0.09}
          />
        </div>
      )}

      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes popIn {
          0% { transform: scale(0.6); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default SpinningWheelGame;
